<div class="app-titulo-pagina-v2">
    <img src="../../../../assets/img/icons/bt_senha_eletrônica_roxo.png" alt="Icone de btn_cadastros">
    <span>Senha Eletrônica</span>
  </div>
<app-submenu></app-submenu>
<div class="container">


    <div class="alert alert-warning" role="alert" style="margin-top: 10px;">
        <h2>Atenção!</h2>
        <p>A 'senha eletrônica' se refere a sua senha pessoal, ela não substituirá a senha enviada juntamente com seu Cartão. Por favor não descarte a senha do seu Cartão pois ela será solicitada para ingresso a este sistema.</p>
        <p>Esta 'senha eletrônica' será solicitada durante suas transações para sua maior segurança.</p>
    </div>

    <form (ngSubmit)="saveEPwd()" class="col-xs-12 col-md-12" ngNativeValidate>
        <div class="panel panel-default app-panel">
            <div class="panel-heading"> Alterar Senha Eletrônica Atual
            </div>  
            <div class="panel-body" >  <!--data-ng-init="epwd.atual = ''"-->
                <div *ngIf="!epwdIsNull" class="form-group col-xs-12 col-md-8 col-md-offset-2">
                    <label for="senhaAtual">Senha Eletrônica Atual</label>
                    <input type="password" id="senhaAtual" [(ngModel)]="epwd.atual" name="atual" class="form-control input-sm input-sm" maxlength="256" required="">
                </div>

                <div class="form-group col-xs-12 col-md-8 col-md-offset-2">
                    <label for="novaSenha">Nova Senha Eletrônica</label>
                    <input type="password" id="novaSenha" [(ngModel)]="epwd.nova" name="nova" class="form-control input-sm input-sm" maxlength="256" required="">
                </div>

                <div class="form-group col-xs-12 col-md-8 col-md-offset-2">
                    <label for="confirmacaoSenha">Confirmação da Nova Senha Eletrônica</label>
                    <input type="password" id="confirmacaoSenha" name="confirmacaoSenha" [(ngModel)]="epwd.confirmacao" class="form-control input-sm input-sm" maxlength="256" required="">
                </div>

                <div class="col-xs-12 text-center">
                    <button id="btnSalvar" type="submit" class="btn btn-success-v2">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </form>

    <div *ngIf="!epwdIsNull" class="col-xs-12 text-center">
        <a (click)="mainService.loginService.changeRoute('/cartao/epwd/reset')">
            <i class="fa fa-envelope"></i> Recuperar minha Senha Eletrônica
        </a>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/epwd/epwd.component.html